// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jOzt","placeholdersHeader":"styles_placeholdersHeader__Rb-iu","editorStyle":"styles_editorStyle__3kDel","placeholdersBox":"styles_placeholdersBox__2BKiA"};